import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AboutMe from "./pages/AboutMe";
import Experience from "./pages/Experience";
import Projects from "./pages/Projects";
import Skills from "./pages/Skills";
import Languages from "./pages/Languages";
import Contacts from "./pages/Contacts";
import Education from "./pages/Education";
import Home from "./pages/Home";
import Certificate from "./pages/Certificates";

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/languages" element={<Languages />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/education" element={<Education />} />
          <Route path="/certificate" element={<Certificate />} />
          {/* <Route path="/events" element={<Events />} /> */}


        </Routes>
        {/* <Footer /> */}
      </div>
    </Router>
  );
}

export default App;
